import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateTime } from 'luxon';
import * as moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { BACKGROUNDIMAGE, IDIOMA, USA_NOITE_EXTRA_PACOTE } from 'src/app/app.config';
import { diffInDays, sameDate, toDateTime, verifyDateMajorThan } from 'src/app/utils/luxon.helper';
import { Busca, Pacote, PacotePeriodo, Paginacao, Quarto, Trecho } from '../../../model';
import { LoginService, Util } from '../../../services';
import { PacotelstService } from '../../../services/turismo/pacotelst.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pacotes',
    templateUrl: './pacotes.component.html',
    styleUrls: ['./pacotes.component.scss'],
    standalone: false
})

export class PacotesComponent implements OnInit {
    // @Input() Orcamento: Pacote[] = [];
    @Input() events: Observable<void>;
    @Input() busca: Busca;

    @Output() pacote;
    @Output() selecionou = new EventEmitter<any>();
    @Output() selecionouPacote = new EventEmitter<any>();
    @Output() avancar = new EventEmitter<any>();
    @Output() removeu = new EventEmitter<any>();
    @Output() atualizarBusca = new EventEmitter<any>();

    private eventsSubscription: Subscription;
    backgroundimage = BACKGROUNDIMAGE;
    paginacao: Paginacao = new Paginacao();
    quarto: Quarto = new Quarto();
    Pacote = new Pacote();
    idioma = IDIOMA;
    PacoteDetalhes: Pacote;
    // dataAtual: any;
    desabilitaTarifa = true;
    semAgencia = false;
    AgenciaId: number;
    Destinos = [];
    Pacotes: Pacote[] = [];
    DestinoId: number = 0;
    datasvalidas = [];
    usaMinNoites = false;
    erros = [];
    mensagemSucesso = '';
    usuarioLogado = null;
    loading: boolean = false;
    minDate: DateTime;
    maxDate: DateTime;
    usa_noite_extra_pacote = USA_NOITE_EXTRA_PACOTE;


    myFilterData = (d: Date): boolean => {
        const date = toDateTime(d);
        return this.datasvalidas.indexOf(date.toFormat("yyyy-MM-dd")) !== -1;
    };

    dataAtual: string;
    minDataVolta: string;

    constructor(
        private modalService: NgbModal,
        private _router: Router,
        private loginService: LoginService,
        private pacotelstservice: PacotelstService,
    ) { }

    ngOnInit() {
        this.buscarPacoteDestino(0);
        this.buscarDestinos();
        this.carregaAgencia();

        this.usuarioLogado = this.loginService.user();
        this.busca.usuario = this.usuarioLogado;
    }

    buscarPacoteDestino(destinoId) {
        this.loading = true;
        this.erros = [];
        this.mensagemSucesso = '';
        let busca = this.pacotelstservice.buscaPacotesDestinos(destinoId, this.paginacao.NumeroPagina);
        busca.subscribe(
            dados => {
                this.loading = false;
                this.Pacotes = dados.Items;
                this.Pacotes.forEach(p => {
                    p.PacoteImagens.forEach(pi => {
                        pi.Imagem = Util.pathImagemApi(pi.Imagem);
                    });

                    p.imagemPrincipal = p.PacoteImagens.length > 0 && p.PacoteImagens.findIndex(x => !x.Banner) !== -1 ? p.PacoteImagens.find(x => !x.Banner)?.Imagem : p.PacoteImagens[0]?.Imagem;
                    p.imagemBanner = p.PacoteImagens.length > 0 && p.PacoteImagens.findIndex(x => x.Banner) !== -1 ? p.PacoteImagens.find(x => x.Banner)?.Imagem : p.PacoteImagens[0]?.Imagem;
                    p.PacotePeriodos.forEach(pp => {
                        pp.CheckinDe = moment(pp.CheckinDe).format("YYYY-MM-DD");
                        pp.CheckoutAte = moment(pp.CheckoutAte).format("YYYY-MM-DD");
                    });
                    p.PacotePeriodos.sort(function (a, b) {
                        return a.CheckinDe - b.CheckinDe;
                    });
                });

                this.paginacao.NumeroPagina = dados.MetaData.NumeroPagina;
                this.paginacao.TotalItens = dados.MetaData.TotalItens;
                this.paginacao.ItensPorPagina = dados.MetaData.itensPorPagina;
                this.paginacao.TotalPaginas = dados.MetaData.TotalPaginas;
            },
            erro => {
                this.loading = false;
                this.Pacotes = [];
                this.erros.push(this.errorHandler(erro, 'Buscar Pacotes'));
            },
        );
    }

    BuscaPacotes() {
        this.semAgencia = false;
        this.busca.primeira = true;
        this.busca.novoOrcamento = true;
        this.busca.PacoteId = this.Pacote.Id;
        if (this.Pacote.BloqueioAereo.length > 0) {
            this.busca.trechos[0].AeroportoPartida = this.Pacote.BloqueioAereo[0].AeroportoPartida;
            this.busca.trechos[0].AeroportoChegada = this.Pacote.BloqueioAereo[0].AeroportoChegada;
        } else {
            this.busca.tipoBusca.aereo = false;
        }
        this.busca.trechos[0].cidadeDestino.Id = this.Pacote.Cidade.Id;
        this.busca.trechos[0].cidadeDestino.Nome = this.Pacote.Cidade.Nome;

        if (this.usuarioLogado.AgenciaId != null) {
            this.busca.AgenciaId = this.usuarioLogado.AgenciaId;
        } else {
            let agencia = window.localStorage.getItem("g8h7d8");
            if (agencia !== null) {
                const agenciaID = JSON.parse(atob(agencia));
                this.busca.AgenciaId = agenciaID.Id;
            } else {
                alert("Selecione uma agência!");
                // alert(this.utilService.fazerTraducao(this.mensagemAlert));
            }
        }
        if (!this.busca.AgenciaId || this.busca.AgenciaId == 0) {
            this.semAgencia = true;
            setTimeout(() => (this.semAgencia = false), 5000);
            return null;
        }

        sessionStorage.removeItem('buscapacote');
        sessionStorage.setItem('buscapacote', JSON.stringify(this.busca));

        this.modalService.dismissAll();
        this.avancar.emit();
    }

    buscarPagina(pagina) {
        this.paginacao.NumeroPagina = pagina;
        document.documentElement.scrollTop = 0;
        this.buscarPacoteDestino(0);
    }

    abrirModal(pacote: Pacote, content) {
        this.desabilitaTarifa = true;
        this.usaMinNoites = false;
        this.Pacote = pacote;
        const busca = this.busca.decodeBuscaNovo(JSON.stringify(this.busca));
        busca.tipoBusca.hotel = true;
        busca.usuario = this.usuarioLogado;
        this.datasvalidas = [];

        if (pacote.PacotePeriodos.length > 0) {
            pacote.PacotePeriodos.forEach((pp: PacotePeriodo, index: number) => {
                this.datasvalidas.push(toDateTime(pp.CheckinDe).toFormat('yyyy-MM-dd'));
                if (index === 0) {
                    busca.trechos[0].dataIda = toDateTime(pp.CheckinDe);
                    this.setDataIda(busca.trechos[0].dataIda, busca.trechos, 0);
                }
            });
            busca.nrnoites = diffInDays(toDateTime(pacote.PacotePeriodos[0].CheckinDe), toDateTime(pacote.PacotePeriodos[0].CheckoutAte));
        } else {
            let dataCheckin = toDateTime(pacote.Checkin);

            // this.minDate = pacote.Checkin < this.getAmanha() ? this.getAmanha() : this.formatarData(pacote.Checkin);
            this.minDate = verifyDateMajorThan(toDateTime(pacote.Checkin), this.getAmanha()) ? this.getAmanha() : dataCheckin;
            this.maxDate = toDateTime(pacote.Checkout);

            this.usaMinNoites = true;
            busca.trechos[0].dataIda = this.minDate;
            busca.trechos[0].dataVolta = this.maxDate;
            this.setDataIda(this.minDate, busca.trechos, 0);
            busca.nrnoites = pacote.MinimoDeNoites;
        }
        this.atualizarBusca.emit(busca);

        sessionStorage.clear();
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' });
    }

    fecharModal() {
        this.modalService.dismissAll();
    }

    carregaAgencia() {
        if (this.AgenciaId == 0) {
            let agencia = window.localStorage.getItem("g8h7d8");
            if (agencia != null) {
                let a = JSON.parse(atob(agencia));
                this.AgenciaId = a.Id;
            }
        }
    }

    setDataIda(event: any, trechos: Trecho[], indice: number = 0) {
        this.desabilitaTarifa = false;

        let periodo = this.Pacote.PacotePeriodos.find(x => sameDate(event, x.CheckinDe));

        let dataIda = toDateTime(event);
        let dataVolta = toDateTime(new Date());

        if (this.usaMinNoites) {
            dataVolta = dataIda.plus({ days: this.Pacote.MinimoDeNoites });
        } else if (periodo) {
            dataVolta = toDateTime(periodo.CheckoutAte);
        }

        trechos[indice].dataIda = dataIda;
        trechos[indice].dataVolta = dataVolta;

        this.busca.nrnoites = diffInDays(dataIda, dataVolta);
    }

    setaDataVolta(event: any, trechos: Trecho[], indice: number = 0) {
        const dataIda = trechos[indice].dataIda;
        const dataVolta = toDateTime(event);

        // Atualiza a data de volta no objeto trecho
        trechos[indice].dataVolta = dataVolta;

        // Recalcula e atualiza o número de noites
        this.busca.nrnoites = diffInDays(dataIda, dataVolta);
    }

    onChangeVolta(event, trechos, indice) {
        this.GetDateDiffVolta(event, trechos, indice);
    }

    GetDateDiffVolta(event: string, trechos, indice) {
        let dataIda = new Date(trechos[indice].dataIda);
        let dataVolta = new Date(event);

        dataIda.setHours(0, 0, 0, 0);
        dataVolta.setHours(0, 0, 0, 0);

        let diffDays = (dataVolta.getTime() - dataIda.getTime()) / (1000 * 60 * 60 * 24);

        this.busca.nrnoites = Math.round(diffDays);
    }

    buscarDestinos() {
        this.pacotelstservice.listDestinos().subscribe(
            dados => {
                this.Destinos = dados;
            },
            erro => {
                console.log(erro);
            },
        );
    }

    public errorHandler(erro, acao: string = null): string {
        let mensagem = 'Erro';
        if (acao !== null) {
            mensagem += ' ao tentar ' + acao + ': ';
        }
        switch (erro.status) {
            case 0: mensagem += 'o servidor não respondeu, tente novamente mais tarde!'; break;
            case 401: mensagem += 'você não tem autorização para executar esta ação!'; break;
            case 404: mensagem += erro.error.mensagem; break;
            case 406: mensagem += 'a requisição não foi aceita, tente novamente!'; break;
            case 500: mensagem += 'Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte'; break;
            default: mensagem += erro.statusText;
        }
        return mensagem;
    }

    getAmanha() {
        return toDateTime(new Date()).plus({ days: 1 });
    }
}
